import React from "react";
import { Bullseye, Alert } from "@patternfly/react-core";

const alertStyle = { width: "50%" };

export default (props) => (
  <Bullseye>
    <Alert style={alertStyle} variant="danger" title="Authentication Error">
      <p>
        User authentication failed:{" "}
        <strong>{`${props && props.error && props.error.message}`}.</strong>
      </p>
      <p>
        Please refresh this page and log in again.{" "}
        <a href="mailto:cp-labs@redhat.com">Contact us</a> if you still see this
        failure.
      </p>
    </Alert>
  </Bullseye>
);
